import Pagination from '@/model/Pagination';
import Sort from '@/model/SortReq';

export default function (other) {
  other = other || {};
  return {
    // Filter fields
    name: other.name || null,
    accountId: other.accountId || null,
    usageType: other.usageType || null,
    status: other.status || null,
    notes: other.notes || null,
    campaignType: other.campaignType || null,
    creationTime: other.creationTime || null,

    orgIds: other.orgIds || [],
    buIds: other.buIds || [],

    // Search
    search: other.search || '',

    // Pagination & Sorting
    pagination: other.pagination || Pagination(),
    sort: other.sort || Sort()
  };
}
